import { FC } from "react";
import Link from "next/link";

const CategoriesLinks: FC<{categories:Array<any>}> = ({categories}) => {

    return (
        <>
        { // to show just one category
            categories && categories?.length > 0 ?
                categories?.length > 1 && categories[0]?.title?.includes('آخر الأخبار') ?
                <Link href={`/category/` + categories[1]?.id+'/'+categories[1]?.title}>
                    <a href="#" aria-label="Go to 56">{categories[1]?.title}</a>
                </Link>
                :
                <Link href={`/category/` + categories[0]?.id+'/'+categories[0]?.title}>
                    <a href="#" aria-label="Go to 57">{ categories[0]?.title}</a>
                </Link>
            : <></>
        }
        </>
    )
}

export default CategoriesLinks